import { Icon, IconProps } from '@chakra-ui/react';

export function SnoozeIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 48 48" fill="none" color="#333333" {...props}>
      {/* Large Z */}
      <polyline
        points="6 28 26 28 6 46 26 46"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Medium Z */}
      <polyline
        points="28 25 40 25 28 37 40 37"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Small Z */}
      <polyline
        points="20 8 28 8 20 16 28 16"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
